import {Component} from "@angular/core";

@Component({
    selector: 'tfl-chevron-bottom',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25">
            <path fill="#616161" fill-rule="evenodd" d="M16.878 9.616a.328.328 0 0 0 0-.51.465.465 0 0 0-.59 0L12 13.597 7.713 9.106a.465.465 0 0 0-.59 0 .327.327 0 0 0 0 .51l4.581 4.756c.172.141.42.141.591 0l4.583-4.756z"/>
        </svg>
    `
})
export class ChevronBottomIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/chevron-bottom.icon.ts